#import "../fragments/calendar-sync.graphql"

mutation setGoogleConflictCalendarSyncIsEnabled($isEnabled: Boolean!) {
    setGoogleCalendarSyncIsEnabled(
        input: {calendarSync: {isEnabled: $isEnabled, isConflictCalendar: true}}
    ) {
        authUrl
        calendarSync {
            ...CalendarSync
        }
        newConnectionId
    }
}
